import React, { Component } from 'react';

import { connect } from 'react-redux';
import { logIn } from '../redux/Actions';

import { api, apiConst } from '../backend/api.js';
import { isThisTypeNode } from 'typescript';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      password: '',
      error: false,
      renew: false,
      response: null
    };
  };

  componentDidMount() {
    document.getElementById('account-email').focus();
  };

  handleChangeEmail = (event) => {
    this.setState({ email: event.target.value.trim(), error: false });
  };

  handleChangePassword = (event) => {
    this.setState({ password: event.target.value.trim(), error: false });
  };

  connect = (e) => {
    e.preventDefault();
    console.log(!!this.state.email.length && !!this.state.password.length)
    if(!!this.state.email.length && !!this.state.password.length) {
      api(apiConst.LOGIN, {email: this.state.email, password: this.state.password}, (resp) => {
        if(!!resp.success) {
          window.localStorage.setItem('jwtToken', resp.token);
          this.props.validate();
        }
        else {
          this.setState({
            password: '',
            error: true
          });
        }
      });
    } else {
      let pwd = document.getElementById('password-input');
      pwd.value = '';
      this.setState({
        password: '',
        error: true
      });
    }
  };

  isAMailAddress(str) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str)) {
      return true;
    }
    return false;
  }

  renew = (e) => {
    e.preventDefault();
    if(this.isAMailAddress(this.state.email)) {
      api(apiConst.MAIL, {mail: this.state.email}, (resp) => {
        if(!!resp.success) {
          window.localStorage.setItem('jwtToken', resp.token);
          console.log({resp})
          
        }
        this.setState({response: resp.success})
      });
    }
    else {
      console.log("wrong mail");
    }
  }

  render() {
    return(
      <div className='fixed-mask'>
        <div className='mask-panel shadow' style={{ width: 300 }}>
          {
            !!this.state.response
            ? (
              <div style={{ flexDirection: "column"}}>
                Un email a été envoyé à l'adresse email renseignée
                <div style={{ margin: "auto", marginTop: 10 }}>
                  <button type={'button'} className='regular-button shadow' onClick={() => this.props.cancel()}>Fermer</button>
                </div>
              </div>
            )
            : (
              <form style={{ display: 'flex', flex: 1 }} action='#' method='post' onSubmit={(e) => this.connect(e)} id='account-form' autoComplete = "off">
                  
                  Email
                  <input id='account-email' className='classic-input account-name-input shadow' type='text' name='email' placeholder='E-mail'
                    value={this.state.email}
                    onChange={this.handleChangeEmail} />
                  {
                    !this.state.renew ? "Mot de passe" : null
                  }
                  {
                    !this.state.renew ? 
                      <input id='password-input' className='classic-input account-name-input shadow' type='password' name='password' placeholder='Mot de passe'
                        value={this.state.password}
                        onChange={this.handleChangePassword} />
                    : null
                  }
                  {
                    !this.state.renew ? 
                      <span id="forgottenPass" onClick={() => this.setState({renew: true})}>Mot de passe oublié ?</span>
                    : null
                  }
                  
                  {
                    this.state.error
                    ? <p style={{ margin: 5, color: 'red'}}>Identifiant invalide</p>
                    : null
                  }
                <div style={{ marginTop: 15 }}>
                  <button type={'button'} className='regular-button shadow' onClick={() => this.props.cancel()}>Annuler</button>
                  <button type={'submit'} className='regular-button shadow' onClick={
                    (e) => {
                      !!this.state.renew
                      ? this.renew(e)
                      : this.connect(e)
                    }
                  }>{!this.state.renew ? "Se connecter": "Réinitialiser"}</button>
                </div>
              </form>
            )
          }
        </div>
      </div>
    );
  };
};


export default connect(null, { logIn })(Account);